import React, { Component } from 'react';
import './Auth.css'
import './timeline.css'
import Login from './login/Login';
import Signup from './signup/Signup';

declare var fbq;

class Auth extends Component {

  constructor(props) {
      super(props);
      this.state = {
        optionSelected: this.props.auth
  };
    this.setAuthOption = this.setAuthOption.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.stepBack = this.stepBack.bind(this);

  }

  componentWillReceiveProps(nextProps) {
    let optionSelected = nextProps.auth
    this.setState({
      optionSelected
    })
  }

  setAuthOption(option) {
    this.setState({
      optionSelected: option
    })
  }

  handleLogin(e) {
    let step = this.props.step;
    step++
    this.props.continue(step)
  }

  stepBack() {
    let step = this.props.step;
    step--
    this.props.continue(step)
  }


  render() {
    return (
       <div className="auth">
        <header>

            <nav>
             <div className="nav-wrapper no-color">
               <a  className="brand-logo center">Ingresar</a>
               <a onClick={this.stepBack} className="button-collapse"><i className="material-icons">keyboard_arrow_left</i></a>
             </div>
            </nav>


         <div className="steps center  animated fadeIn  row">
           <div className="col s12">
           <ul className="timeline" id="timeline">
             <li className="li complete">
               <div className="timestamp">
                 <span className="author">Ingresar</span>
               </div>
               <div className="status">

               </div>
             </li>
             <li className="li ">
               <div className="timestamp">
                 <span className="author">Envio</span>
               </div>
               <div className="status">
               </div>
             </li>
             <li className="li">
               <div className="timestamp">
                 <span className="author">Ordenar</span>
               </div>
               <div className="status">
               </div>
             </li>
            </ul>
         </div>
         </div>
        </header>

        { !this.state.optionSelected  &&

           <div className="container animated fadeInLeft create">
            <div className="row center">
                  <h3>¿Ya tienes cuenta de Rappi?</h3>
                  <p>¡Debes ingresar para disfrutar de la promo!</p>
                  <div className="col s6">
                      <a className="btn waves-effect waves-light" onClick={() => this.setAuthOption('login')}>¡Si tengo!</a>
                  </div>
                    <div className="col s6">
                    <a className="btn btn-inverse waves-light" onClick={ () =>  this.setAuthOption('signup')}>Aún no</a>
                  </div>
            </div>
           </div>

       }
        {this.state.optionSelected  === 'login'  &&
            <div>
              <Login logued={this.handleLogin.bind(this)}></Login>
              <div className="row animated fadeInLeft center">
              <a className="btn-flat waves-effect waves-green" onClick={ () =>  this.setAuthOption('signup')}>No  tengo una cuenta!</a>
              </div>
            </div>
        }
        { this.state.optionSelected === 'signup'  &&
            <div>
              <Signup logued={this.handleLogin.bind(this)}></Signup>
              <div className="row   animated fadeInLeft center">
                <a className="btn-flat waves-effect waves-green" onClick={() => this.setAuthOption('login')}>Ya tengo una cuenta!!</a>
              </div>
            </div>
        }

      </div>
    );
  }


}


export default Auth;



// WEBPACK FOOTER //
// ./src/components/auth/Auth.js